import { ChangeDetectionStrategy, Component, ElementRef, input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import {faArrowUpRightFromSquare, faCircleInfo} from '@fortawesome/free-solid-svg-icons';
import { map, Observable, of, startWith } from 'rxjs';
import { AssessmentService } from 'src/app/services/assessment.service';
import { SummaryService } from 'src/app/services/summary.service';

@Component({
  selector: 'app-current-status',
  templateUrl: './current-status.component.html',
  styleUrls: ['./current-status.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CurrentStatusComponent implements OnInit {
  faCircleInfo = faCircleInfo;

  user = input.required<any>();
  public = input.required<boolean>();

  today = new Date();
  summaryInfo: any;
  summaryInfoSelected: any;
  summaryInfoRegion: any;
  summaryInfoForest: any;

  //dropdown lists
  regions: any;
  yearsArray: any;

  //forest name filter
  selectedForestFlag = false;
  forestNameList: string[];
  filtered_forest_names: Observable<string[]>;
  @ViewChild('forest') input?: ElementRef<HTMLInputElement>;
  forest_name = new FormControl("")
  selectedRegion: string | undefined = undefined;

  //search bar items
  filters = {
    region: null,
    forest_name: null as (string | null),
    fire_discovery_years: null as (number | null),
  }
  filters_clean = true;
  type: any;

  constructor(
    private readonly titleService: Title,
    private readonly assessmentService: AssessmentService,
    private readonly summaryService: SummaryService,
  ) {
    this.titleService.setTitle("BAER - Current Status"); this.regions = this.assessmentService.getRegionList();
    this.forestNameList = this.assessmentService.getForestNameList();
    this.filtered_forest_names = of(this.forestNameList)

    this.assessmentService.finishLoadingSubscription().subscribe(() => {
      this.regions = this.assessmentService.getRegionList();
      this.forestNameList = this.assessmentService.getForestNameList(this.filters.region as any);

      this.filtered_forest_names = of(this.forestNameList)
      this.filtered_forest_names = this.forest_name.valueChanges.pipe(
        startWith(""),
        map((value) => this._filter((value as string) || ""))
      )
    })

    const currentYear = new Date().getFullYear();
    const numberOfYears = 3; // You can change this to the desired number of years
    this.yearsArray = Array.from({ length: numberOfYears }, (_, i) => currentYear - i);
    this.filters.fire_discovery_years = this.yearsArray[0];
    this.filters_clean = false;
  }

  ngOnInit(): void {
    this.filtered_forest_names = this.forest_name.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )

    this.summaryService.getSummary().subscribe((summaryInfo: any) => {
      this.summaryInfo = summaryInfo;

      if (this.user().woOffice) {
        this.type = 'WO';
      } else if (this.user().regionOffice) {
        this.type = 'RO';
        this.filters.region = this.user().regionOffice.region
      } else {
        this.type = 'FO';
        this.filters.region = this.user().forestOffice.region;
        this.forest_name.setValue(this.user().forestOffice.forest_name);
      }
      this.setSummary();
    })
  }

  setSummary() {
    if (this.forest_name.value) { //forest level
      this.type = 'FO';
      this.summaryInfoSelected = this.summaryInfo.find((data: any) => data.discovery_year == this.filters.fire_discovery_years && data.region == this.filters.region && data.forest_name == this.forest_name.value);
      this.summaryInfoRegion = undefined;
      this.summaryInfoForest = undefined;
    } else if (this.filters.region) { //region level
      this.type = 'RO';
      this.summaryInfoSelected = this.summaryInfo.find((data: any) => data.discovery_year == this.filters.fire_discovery_years && data.region == this.filters.region && data.forest_name == 'region total');
      this.summaryInfoForest = this.summaryInfo.filter((data: any) => data.discovery_year == this.filters.fire_discovery_years && data.region == this.filters.region && data.forest_name != 'region total');
      this.summaryInfoForest = this.summaryInfoForest.sort((a: any, b: any) => a.total_auth < b.total_auth ? 1 : -1);
      this.summaryInfoRegion = undefined;
    } else { //wo level
      this.type = 'WO';
      this.summaryInfoSelected = this.summaryInfo.find((data: any) => data.discovery_year == this.filters.fire_discovery_years && data.region == 'WO');
      this.summaryInfoForest = undefined;
      this.summaryInfoRegion = this.summaryInfo.filter((data: any) => data.discovery_year == this.filters.fire_discovery_years && data.region != 'WO' && data.forest_name == 'region total');
      this.setBlankRegions();
      this.summaryInfoRegion = this.summaryInfoRegion.sort((a: any, b: any) => a.total_auth < b.total_auth ? 1 : -1);
    }

    if (!this.summaryInfoSelected) { //set empty record since no assessments exist yet for the given selection
      this.summaryInfoSelected = {
        "plants": 0, "groundCover": 0, "channel": 0, "heritage": 0, "roads": 0, "trails": 0, "safety": 0, "monitoring": 0,
        "totalRequested": 0,
        "roAuth": 0, "woAuth": 0, "totalAuth": 0,
        "within2Weeks": 0,
        "pendingStartDate": 0,
        "preSizeUp": 0, "needed": 0, "noAssessment": 0, "inProgress": 0, "submitted": 0, "fundingAuthorized": 0, "teamLeadAssigned": 0,
        "fsAcresPreSizeUp": null, "fsAcresNeeded": null, "fsAcresNoAssessment": null, "fsAcresInProgress": null, "fsAcresSubmitted": null, "fsAcresFundingAuthorized": null, "fsAcresTeamLeadAssigned": null,
        "requestedFundsPreSizeUp": null, "requestedFundsNeeded": null, "requestedFundsNoAssessment": null, "requestedFundsInProgress": null, "requestedFundsSubmitted": null, "requestedFundsFundingAuthorized": null, "requestedFundsTeamLeadAssigned": null,
        "authFundsPreSizeUp": null, "authFundsNeeded": null, "authFundsNoAssessment": null, "authFundsInProgress": null, "authFundsSubmitted": null, "authFundsFundingAuthorized": null, "authFundsTeamLeadAssigned": null
      }
    }
  }

  setBlankRegions() {
    let regions = ['01', '02', '03', '04', '05', '06', '08', '09', '10'];
    regions.forEach((region: any) => {
      const record = this.summaryInfoRegion.find((entry: any) => entry.region == region);
      if (!record) this.summaryInfoRegion.push({
        "region": region, auth_funds_funding_authorized: null,
        auth_funds_in_progress: 0,
        auth_funds_needed: 0,
        auth_funds_no_assessment: 0,
        auth_funds_pre_size_up: 0,
        auth_funds_submitted: null,
        auth_funds_team_lead_assigned: null,
        channel: 0,
        channel_req: 0,
        discovery_year: null,
        fire_acres: 0,
        fire_count: 0,
        forest_name: "region total",
        fs_acres_funding_authorized: null,
        fs_acres_in_progress: 0,
        fs_acres_needed: 0,
        fs_acres_no_assessment: 0,
        fs_acres_pre_size_up: 0,
        fs_acres_submitted: null,
        fs_acres_team_lead_assigned: null,
        funding_authorized: 0,
        ground_cover: 0,
        ground_cover_req: 0,
        heritage: 0,
        heritage_req: 0,
        in_progress: 0,
        monitoring: 0,
        monitoring_req: 0,
        needed: 2,
        nfs_acres: 0,
        no_assessment: 0,
        pending_start_date: 0,
        plants: 0,
        plants_req: 0,
        pre_size_up: 0,
        requested_funds_funding_authorized: null,
        requested_funds_in_progress: null,
        requested_funds_needed: null,
        requested_funds_no_assessment: null,
        requested_funds_pre_size_up: null,
        requested_funds_submitted: null,
        requested_funds_team_lead_assigned: null,
        ro_auth: 0,
        roads: 0,
        roads_req: 0,
        safety: 0,
        safety_req: 0,
        submitted: 0,
        team_lead_assigned: 0,
        total_auth: 0,
        total_req: null,
        trails: 0,
        trails_req: 0,
        within_2_weeks: 0,
        wo_auth: 0
      })
    })
  }

  //filter actions -----------------------------------------------------------------------------------
  regionChanged(): void {
    this.clearForest();
    this.forestNameList = this.assessmentService.getForestNameList(this.filters.region as any);
    this.filtered_forest_names = this.forest_name.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )
    this.search();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.forestNameList.filter((option: string) =>
      option.toLowerCase().includes(filterValue)
    )
  }

  filter(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_forest_names = of(this._filter(filterValue));
  }

  search(): void {
    this.filters_clean = false;
    this.setSummary();
  }

  clearForest() {
    if (!this.selectedForestFlag) {
      this.forest_name.setValue("")
    }
    this.selectedForestFlag = false;
  }

  forestSelected() {
    this.search();
    this.selectedForestFlag = true;
  }

  clearSearch(): void {
    this.filters_clean = true;
    this.filters = {
      region: null,
      forest_name: null,
      fire_discovery_years: new Date().getFullYear(),
    }
    this.forest_name.setValue("");
    this.regionChanged();
    this.search();
  }

  changeFilter(event: any) {
    if (event.type == 'region') {
      this.filters.region = event.filter_item;
      this.regionChanged();
    } else {
      this.forest_name.setValue(event.filter_item);
      this.forestSelected();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  indexChange(a: any) { }

  protected readonly faArrowUpRightFromSquare = faArrowUpRightFromSquare;
}
